/* =============================================================================
   Crédit magasin BinderPOS — traduction FR + application FIABLE du rabais.

   POURQUOI CE FICHIER EXISTE (2026-08-12)
   ---------------------------------------
   Le script de BinderPOS (portal.binderpos.com/shopify/js/credit.js) applique le
   crédit ainsi : il POST le montant sur leur API, reçoit un VRAI code de rabais
   Shopify qu'ils viennent de créer, fait fetch('/discount/CODE') puis clique
   immédiatement sur input[name="checkout"].

   Le bogue : un code fraîchement créé met 1 à 2 secondes à devenir utilisable côté
   Shopify. Leur script ne l'attend pas. Le client arrive donc au paiement AVANT que
   le code soit actif, la caisse se génère au plein montant, et le rabais n'apparaît
   que si on recharge plus tard. Laurianne a vu 372,50 $ avec un bouton « Payer
   maintenant » sous les yeux : payer là, c'était payer le plein prix.

   LA SOLUTION est celle que l'ancien site headless utilisait déjà
   (.builder/taverne-du-collectionneur/app/api/store-credit/route.ts) : ne PAS aller
   au paiement tant que le code n'est pas confirmé applicable, et RÉAPPLIQUER le
   MÊME code (jamais en recréer un) jusqu'à ce qu'il le soit.

   Vérifié sur ce magasin : /cart.js renvoie discount_codes:[{code, applicable}].
   C'est exactement le drapeau `applicable` que le headless lisait via l'API
   Storefront. On tient donc le même signal de confirmation.

   On n'a PAS touché au script de BinderPOS. On intercepte le clic sur
   [name="checkout"] en phase de CAPTURE : le formulaire n'est jamais soumis, donc
   leur onsubmit ne se déclenche pas et on garde la main. Si ce fichier ne charge
   pas, leur flux d'origine reprend le dessus (dégradé, mais fonctionnel).
   ============================================================================= */
(function () {
  'use strict';

  var STORE_UUID = '3d61c067-1128-4dee-b3a3-2e9d09f5522b';
  var BASE = 'https://portal.binderpos.com/external/shopify/' + STORE_UUID + '/storeCredit/forMe';
  var EN = (document.documentElement.getAttribute('lang') || 'fr').toLowerCase().indexOf('en') === 0;

  // Attente max avant d'abandonner : 16 essais x 700 ms ~ 11 s.
  var TRIES = 16, DELAY = 700;

  var T = EN ? {
    checking: 'Applying your store credit...',
    slow: 'Almost there, confirming the discount...',
    late: 'Your credit could not be confirmed in time. Nothing was charged. Please try again in a moment.',
    net: 'Network error. Your credit was not applied.',
    noCred: 'Not enough store credit for this amount.'
  } : {
    checking: 'Application de votre crédit magasin...',
    slow: 'Presque terminé, confirmation du rabais...',
    late: "Votre crédit n'a pas pu être confirmé à temps. Rien n'a été facturé. Réessayez dans un instant.",
    net: "Erreur réseau. Le crédit n'a pas été appliqué.",
    noCred: "Crédit magasin insuffisant pour ce montant."
  };

  function customerId() {
    try { if (window.__st && window.__st.cid) return String(window.__st.cid); } catch (e) {}
    return '';
  }

  function creditAmount() {
    var el = document.getElementById('binderpos-credit-input');
    if (!el) return 0;
    var v = parseFloat(el.value);
    return isFinite(v) && v > 0 ? v : 0;
  }

  // ---------------------------------------------------------------- overlay
  var ov = null, ovTxt = null;
  function showOverlay(text) {
    if (!ov) {
      ov = document.createElement('div');
      ov.id = 'nk-credit-overlay';
      ov.setAttribute('style', 'position:fixed;inset:0;z-index:1000000000;display:flex;align-items:center;' +
        'justify-content:center;background:rgba(9,14,26,.72);backdrop-filter:blur(2px);');
      var box = document.createElement('div');
      box.setAttribute('style', 'max-width:340px;margin:0 20px;padding:26px 24px;border-radius:14px;text-align:center;' +
        'background:#131d31;border:1px solid rgba(196,154,76,.35);box-shadow:0 24px 60px -20px rgba(0,0,0,.7);');
      var dot = document.createElement('div');
      dot.setAttribute('style', 'width:30px;height:30px;margin:0 auto 14px;border-radius:9999px;' +
        'border:3px solid rgba(196,154,76,.25);border-top-color:#c49a4c;animation:nkCredSpin .8s linear infinite;');
      ovTxt = document.createElement('p');
      ovTxt.setAttribute('style', "margin:0;font-family:'Inter',system-ui,sans-serif;font-size:14px;line-height:1.5;color:#f3ece0;");
      var st = document.createElement('style');
      st.textContent = '@keyframes nkCredSpin{to{transform:rotate(360deg)}}';
      box.appendChild(st); box.appendChild(dot); box.appendChild(ovTxt);
      ov.appendChild(box);
    }
    ovTxt.textContent = text;
    if (!ov.parentNode) document.body.appendChild(ov);
  }
  function hideOverlay() { if (ov && ov.parentNode) ov.parentNode.removeChild(ov); }

  function alertBox(msg) {
    hideOverlay();
    var o = document.createElement('div');
    o.setAttribute('style', 'position:fixed;inset:0;z-index:1000000001;display:flex;align-items:center;' +
      'justify-content:center;background:rgba(9,14,26,.72);');
    var b = document.createElement('div');
    b.setAttribute('style', 'max-width:360px;margin:0 20px;padding:24px;border-radius:14px;text-align:center;' +
      'background:#131d31;border:1px solid rgba(196,154,76,.35);');
    var p = document.createElement('p');
    p.setAttribute('style', "margin:0 0 18px;font-family:'Inter',system-ui,sans-serif;font-size:14px;line-height:1.5;color:#f3ece0;");
    p.textContent = msg;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = EN ? 'Close' : 'Fermer';
    btn.setAttribute('style', "border:0;border-radius:9999px;background:#c49a4c;color:#fff;cursor:pointer;" +
      "font-family:'Space Mono',monospace;font-size:11px;font-weight:700;letter-spacing:.08em;" +
      'text-transform:uppercase;padding:11px 22px;');
    btn.addEventListener('click', function () { o.parentNode && o.parentNode.removeChild(o); });
    b.appendChild(p); b.appendChild(btn); o.appendChild(b);
    document.body.appendChild(o);
  }

  // ------------------------------------------------------------- API crédit
  // POST -> { valid, discountCode, reason }. Endpoint ouvert (CORS *), aucun jeton.
  function createDiscount(cid, amount) {
    return fetch(BASE + '?shopifyCustomerId=' + encodeURIComponent(cid), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
      body: JSON.stringify({ credit: String(amount) })
    }).then(function (r) { return r.json(); });
  }

  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  // Applique le code au panier puis confirme via /cart.js qu'il est APPLICABLE.
  // On réapplique le MÊME code à chaque tour : aucun code en double n'est créé.
  function applyUntilApplicable(code) {
    var n = 0;
    function attempt() {
      return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .then(function () {
          return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var list = (cart && cart.discount_codes) || [];
          for (var i = 0; i < list.length; i++) {
            if (list[i].code === code && list[i].applicable) return true;
          }
          n++;
          if (n >= TRIES) return false;
          if (n === 4) showOverlay(T.slow);
          return wait(DELAY).then(attempt);
        });
    }
    return attempt();
  }

  // Un seul code par session de tentative : si le client reclique, on repart du
  // même code au lieu d'en générer un nouveau chez BinderPOS.
  var lastCode = null;

  // Sur /cart, on empêche la soumission du formulaire : la note du client serait
  // perdue. On la sauve d'abord via l'API panier (sans bloquer si ça échoue).
  function preserveCartNote() {
    var n = document.getElementById('CartSpecialInstructions');
    if (!n || !n.value) return Promise.resolve();
    return fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: n.value })
    }).catch(function () {});
  }

  function runCreditCheckout(amount) {
    var cid = customerId();
    showOverlay(T.checking);
    preserveCartNote();

    var step = lastCode
      ? Promise.resolve({ valid: true, discountCode: lastCode })
      : createDiscount(cid, amount);

    step.then(function (res) {
      if (!res || !res.valid || !res.discountCode) {
        var why = (res && res.reason) ? String(res.reason) : T.noCred;
        alertBox(why);
        return null;
      }
      lastCode = res.discountCode;
      return applyUntilApplicable(res.discountCode);
    }).then(function (ok) {
      if (ok === null) return;              // refusé, message déjà affiché
      if (ok) { window.location.href = '/checkout'; return; }
      alertBox(T.late);                     // jamais de redirection au plein montant
    }).catch(function (e) {
      console.error('[nk-credit]', e);
      alertBox(T.net);
    });
  }

  // ------------------------------------------------------- interception clic
  // Phase de CAPTURE sur document : on passe avant le handler du formulaire, donc
  // avant le onsubmit de BinderPOS. preventDefault empêche toute soumission.
  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('[name="checkout"]') : null;
    if (!btn) return;
    var amount = creditAmount();
    if (!amount) return;                    // pas de crédit demandé : flux normal
    if (!customerId()) return;              // pas connecté : flux normal
    e.preventDefault();
    e.stopPropagation();
    runCreditCheckout(amount);
  }, true);

  // ------------------------------------------------------- traduction FR
  // Le widget est injecté après coup. Chaque bloc est IDEMPOTENT (on ne réécrit
  // que si ce n'est pas déjà traduit). PAS de MutationObserver sur le document :
  // réécrire innerHTML dans un observer childList créait une BOUCLE INFINIE.
  function updateCreditTexts() {
    if (EN) return;
    var p = document.querySelector('.binderpos-credit-input-div p');
    if (p && p.textContent.indexOf('Payer avec le cr') === -1) {
      var dyn = p.querySelector('span.creditBlock');
      p.innerHTML = "<i class='fas fa-money-check-alt'></i> Payer avec le crédit magasin " + (dyn ? dyn.outerHTML : '');
    }
    var cb = document.querySelector('.creditBlock');
    if (cb && cb.textContent.indexOf('disponible') === -1) {
      var m = cb.textContent.match(/\$[\d.]+/);
      if (m) cb.textContent = m[0] + ' disponible';
    }
    var lbl = document.querySelector('.binderpos-credit-use-div label');
    if (lbl && lbl.textContent.indexOf('Entrez le montant') === -1) {
      // Libelle court : l'ancien (« Entrez le montant que vous souhaitez utiliser »)
      // prenait deux lignes a lui seul dans le tiroir iPhone.
      lbl.textContent = 'Montant \u00E0 utiliser';
    }
    var v = document.querySelector('.binderpos-store-credit-loader-text');
    if (v && v.textContent.indexOf('Validation') === -1) {
      v.textContent = 'Validation de votre crédit magasin...';
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      updateCreditTexts();
      if (tries >= 40) clearInterval(iv);   // ~32 s max
    }, 800);
  });
})();
